import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=f2ae5d50&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"
import style0 from "./Clients.vue?vue&type=style&index=0&id=f2ae5d50&prod&lang=css"
import style1 from "./Clients.vue?vue&type=style&index=1&id=f2ae5d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ae5d50",
  null
  
)

export default component.exports